import { useEffect } from "react";

const DEFAULT_TITLE =
  "Brinckmann Arbeitsbühnen – Vermietung von Arbeitsbühnen & Höhenzugangstechnik";
const DEFAULT_DESCRIPTION =
  "Bundesweite Vermietung von Arbeitsbühnen, Scherenbühnen, Teleskopbühnen und Höhenzugangstechnik – Brinckmann Arbeitsbühnen GmbH, Bocholt.";
const SITE = "https://www.brinckmann-arbeitsbuehnen.de";

// Legt fehlende <meta>/<link> im <head> an bzw. aktualisiert vorhandene.
const setTag = (selector, idAttr, idValue, valueAttr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    el.setAttribute(idAttr, idValue);
    document.head.appendChild(el);
  }
  el.setAttribute(valueAttr, value);
};

// Setzt Titel, Meta-Description, Canonical und OG/Twitter-Angaben je Seite.
const Seo = ({ title, description }) => {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESCRIPTION;
    const url = SITE + window.location.pathname;

    document.title = t;
    setTag('meta[name="description"]', "name", "description", "content", d);
    setTag('meta[property="og:title"]', "property", "og:title", "content", t);
    setTag('meta[property="og:description"]', "property", "og:description", "content", d);
    setTag('meta[property="og:url"]', "property", "og:url", "content", url);
    setTag('meta[name="twitter:title"]', "name", "twitter:title", "content", t);
    setTag('meta[name="twitter:description"]', "name", "twitter:description", "content", d);
    setTag('link[rel="canonical"]', "rel", "canonical", "href", url);
  }, [title, description]);

  return null;
};

export default Seo;
